import _omit from "lodash/omit";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable react/prop-types */
import React from 'react';
import { css } from '@emotion/core';
import { Map, fromJS } from 'immutable';
import { getEditorControl, getEditorComponents } from "../index";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1xfnuhy-Shortcode",
  styles: "margin-top:0;margin-bottom:16px;&:first-of-type{margin-top:0;};label:Shortcode;"
} : {
  name: "1xfnuhy-Shortcode",
  styles: "margin-top:0;margin-bottom:16px;&:first-of-type{margin-top:0;};label:Shortcode;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export default class Shortcode extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      field: Map()
    });
  }

  componentDidMount() {
    const {
      node,
      typeOverload
    } = this.props;
    const plugin = getEditorComponents().get(typeOverload || node.data.get('shortcode'));
    const fieldKeys = ['id', 'fromBlock', 'toBlock', 'toPreview', 'pattern', 'icon'];
    const field = fromJS(_omit(plugin, fieldKeys));
    this.setState({
      field
    });
  }

  render() {
    const {
      editor,
      node,
      dataKey = 'shortcodeData'
    } = this.props;
    const {
      field
    } = this.state;
    const EditorControl = getEditorControl();
    const value = dataKey === false ? node.data : fromJS(node.data.get(dataKey));

    function handleChange(fieldName, value, metadata) {
      const dataValue = dataKey === false ? value : node.data.set('shortcodeData', value);
      editor.setNodeByKey(node.key, {
        data: dataValue || Map(),
        metadata
      });
    }

    function handleFocus() {
      return editor.moveToRangeOfNode(node);
    }

    return !field.isEmpty() && ___EmotionJSX("div", {
      onClick: handleFocus,
      onFocus: handleFocus
    }, ___EmotionJSX(EditorControl, {
      css: _ref,
      value: value,
      field: field,
      onChange: handleChange,
      isEditorComponent: true,
      isNewEditorComponent: node.data.get('shortcodeNew'),
      isSelected: editor.isSelected(node)
    }));
  }

}